import React from 'react';
import { IconProps } from '../types';

interface CustomIconProps extends IconProps {
  viewBox?: string;
  role?: string;
  'aria-hidden'?: boolean;
}

export const SsfOpenOn = React.memo<CustomIconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
    width,
    height,
    role = 'img',
    'aria-hidden': ariaHidden = false,
  }) => (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? size}
      height={height ?? size}
      className={className}
      onClick={onClick}
      role={role}
      aria-hidden={ariaHidden}
      style={{ cursor: onClick ? 'pointer' : 'inherit' }}
    >
      <path
        d="M6.48715 10L2.30017 10.0005"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
      />
      <path
        d="M6.48715 10L2.30017 10.0005"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M5.15125 7.25L7.90125 10L5.15125 12.75"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M13.5125 10L17.6995 10.0005"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M14.8484 7.25L12.0984 10L14.8484 12.75"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M10 3V17"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  ),
);

SsfOpenOn.displayName = 'SsfOpenOn';
